import { START_LOCATION, createRouter, createWebHistory } from 'vue-router';

// The landing page is loaded eagerly (it is the entry route and drives LCP).
// Every other route is code-split via dynamic import so its JS is only fetched
// when that route is visited, keeping the initial bundle small.
import Index from '@/pages/Index.vue';

const Calculator = () => import('@/pages/Calculator.vue');
const PaymentSuccess = () => import('@/pages/PaymentSuccess.vue');
const Preview = () => import('@/pages/Preview.vue');
const PrivacyPolicy = () => import('@/pages/PrivacyPolicy.vue');
const TermsAndConditions = () => import('@/pages/TermsAndConditions.vue');
const BlogArticle = () => import('@/pages/blog/BlogArticle.vue');
const BlogIndex = () => import('@/pages/blog/BlogIndex.vue');
const NotFound = () => import('@/pages/NotFound.vue');

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index,
    meta: {
      title: 'Direct Exteriors - Expert Roofing Solutions',
      description:
        'Get accurate roofing estimates and professional installation services. We specialize in residential and commercial roofing with over 15 years of experience.',
    },
  },
  {
    path: '/calculator',
    name: 'Calculator',
    component: Calculator,
    meta: {
      title: 'Roofing Calculator - Direct Exteriors',
      description:
        'Get an instant roofing estimate with our advanced calculator. Enter your address and get a detailed quote for your roofing project.',
    },
  },
  {
    path: '/preview/:uuid',
    name: 'Preview',
    component: Preview,
    meta: {
      title: 'Job Preview - Direct Exteriors',
      description:
        'Review your roofing job details, schedule installation, and complete payment. Secure your project with Direct Exteriors.',
    },
  },
  {
    path: '/payment-success',
    name: 'PaymentSuccess',
    component: PaymentSuccess,
    meta: {
      title: 'Payment Successful - Direct Exteriors',
      description:
        'Your deposit has been received and your roofing job is confirmed. Thank you for choosing Direct Exteriors.',
    },
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    meta: {
      title: 'Privacy Policy - Direct Exteriors',
      description:
        'Learn how Direct Exteriors collects, uses, and protects your information when you request a roofing estimate and schedule your project online.',
    },
  },
  {
    path: '/terms-and-conditions',
    name: 'TermsAndConditions',
    component: TermsAndConditions,
    meta: {
      title: 'Terms & Conditions - Direct Exteriors',
      description:
        'Read the terms and conditions for using Direct Exteriors digital roofing estimate, job preview, scheduling, and payment experience.',
    },
  },
  {
    path: '/financing',
    redirect: '/',
  },
  {
    path: '/blog',
    name: 'Blog',
    component: BlogIndex,
    meta: {
      title: 'Roofing Blog - Direct Exteriors',
      description:
        'Expert roofing guides and tips on roof repair, replacement, and maintenance from Direct Exteriors.',
    },
  },
  {
    path: '/blog/:slug',
    name: 'BlogArticle',
    component: BlogArticle,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
    meta: {
      title: 'Page Not Found - Direct Exteriors',
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (from === START_LOCATION) return { top: 0 };
    if (savedPosition) return savedPosition;
    // section links scroll smoothly themselves (HomeNavbar, Index.vue)
    if (to.hash || to.path === from.path) return false;
    return { top: 0 };
  },
});

// Update document title and meta description on route change
router.beforeEach((to) => {
  // Update document title
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = 'Direct Exteriors - Expert Roofing Solutions';
  }

  // Update meta description
  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription && to.meta.description) {
    metaDescription.setAttribute('content', to.meta.description);
  }
});

export default router;
